import { TermsFilters } from './blocks/side-nav';
import { HeroBanner } from './blocks/hero-banner';
import { HorizontalNavigation } from './blocks/horizontal-navigation';
import { FooterHorizontalNavigation } from './blocks/footer-horizontal-navigation';
import { MobileNavigation } from "./template/header";
import { SubmenuNavigation } from "./template/header";

/**
 * Initialize flex-scroll containers by centering active items
 * Runs early to prevent visual jump on page load
 */
function initFlexScrollContainers() {
    document.querySelectorAll('.flex-scroll').forEach(container => {
        const activeItem = container.querySelector('.active, .current-menu-item');
        if (activeItem) {
            const scrollLeft = activeItem.offsetLeft - (container.clientWidth / 2) + (activeItem.clientWidth / 2);
            container.scrollLeft = scrollLeft;
        }
        // Add initialized class to fade in the container
        container.classList.add('initialized');
    });
}

// Run immediately if DOM is ready, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlexScrollContainers);
} else {
    initFlexScrollContainers();
}

document.addEventListener('DOMContentLoaded', () => {
    new TermsFilters();
    new HeroBanner();
    new HorizontalNavigation('.wp-block-navigation__container', '.nav-arrow.left', '.nav-arrow.right', '.horizontal-navigation');
    new FooterHorizontalNavigation('.wp-block-navigation__container', '.nav-arrow.left', '.nav-arrow.right', '.footer-horizontal-nav');
    new MobileNavigation();
    new SubmenuNavigation();

    jQuery('.wp-block-navigation__responsive-container-open').off('click');
    jQuery('.wp-block-navigation__responsive-container.hidden-by-default').closest('.wp-block-navigation').addClass('has-background');
    jQuery('.wp-block-navigation__responsive-container-open').on('click', function (event) {

        const topNavMenu = jQuery('.wp-block-navigation__responsive-container.hidden-by-default');
        if (topNavMenu.hasClass('is-menu-open')) {
            jQuery('html').removeClass('has-modal-open');
            topNavMenu.removeClass('is-menu-open');
        } else {
            jQuery('html').addClass('has-modal-open');
            topNavMenu.addClass('is-menu-open');
        }

        event.stopPropagation();
        event.preventDefault();

        return false;
    });

});


// Live Chat
document.addEventListener('DOMContentLoaded', function () {

    const header = document.querySelector('header.wp-block-template-part');
    let ticking = false;

    const updateHeader = () => {
        header.classList.toggle('is-top', window.scrollY === 0);
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        
        if (!ticking) {

            ticking = true;

            try {

                if (window.requestAnimationFrame) {
                    window.requestAnimationFrame(updateHeader);
                } else {
                    setTimeout(updateHeader, 50); 
                }

            } catch (e) {

                ticking = false;
            
            }

            
        }
    
    });
    
    const liveChatButtons = document.querySelectorAll('.live-chat-btn');
    if (!liveChatButtons.length) {
        return;
    }

    window.__lc = window.__lc || {};
    window.__lc.group = 1;
    window.__lc.license = 19274688;
    window.__lc.integration_name = "manual_onboarding";
    window.__lc.product_name = "livechat";
    
    (function(n, t, c) {
        function i(n) {
            return e._h ? e._h.apply(null, n) : e._q.push(n)
        }
        var e = {
            _q: [],
            _h: null,
            _v: "2.0",
            on: function() {
                i(["on", c.call(arguments)])
            },
            once: function() {
                i(["once", c.call(arguments)])
            },
            off: function() {
                i(["off", c.call(arguments)])
            },
            get: function() {
                if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
                return i(["get", c.call(arguments)])
            },
            call: function() {
                i(["call", c.call(arguments)])
            },
            init: function() {
                var n = t.createElement("script");
                n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n);
            }
        };
        !n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e
    }(window, document, [].slice));

    liveChatButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            if (window.LiveChatWidget) {
                LiveChatWidget.call('maximize');
            }
        });
    });

    if (typeof userobject != "undefined" && userobject && userobject.id) {
        window.__lc.visitor = {
            name: userobject.firstName + ' ' + userobject.lastName,
            email: userobject.email
        };
    }
  
});

